import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-461ef7a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orderCouier" }
const _hoisted_2 = { class: "couier-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "couier-title" }, "物流信息", -1))
const _hoisted_4 = { class: "couier-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "couier-name-left" }, "快递公司:", -1))
const _hoisted_6 = { class: "couier-name-right" }
const _hoisted_7 = { class: "couier-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "couier-name-left" }, "运单号:", -1))
const _hoisted_9 = { class: "couier-name-right" }
const _hoisted_10 = { class: "couier-right" }
const _hoisted_11 = { class: "couier-right-contents" }
const _hoisted_12 = { class: "couier-right-contents-c" }
const _hoisted_13 = { class: "right" }
const _hoisted_14 = {
  key: 0,
  class: "title"
}
const _hoisted_15 = {
  key: 1,
  class: "title"
}
const _hoisted_16 = {
  key: 2,
  class: "title"
}
const _hoisted_17 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.orderData.datas.expressname), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.orderData.datas.expressnumber), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryList.data.list, (delivery, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "right-item",
              key: index
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["item-left", {'item-left-active':index==0}])
              }, _toDisplayString(delivery.time), 3),
              _createElementVNode("div", _hoisted_13, [
                (index==0&&_ctx.deliveryList.data.list.length>1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.deliveryStatus), 1))
                  : (index==_ctx.deliveryList.data.list.length-1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "已揽件"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_16, "运输中")),
                _createElementVNode("p", _hoisted_17, _toDisplayString(delivery.status), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}